import { render, staticRenderFns } from "./HelpDeskOverview.vue?vue&type=template&id=c8fc90e8&scoped=true&"
import script from "./HelpDeskOverview.vue?vue&type=script&lang=js&"
export * from "./HelpDeskOverview.vue?vue&type=script&lang=js&"
import style0 from "./HelpDeskOverview.vue?vue&type=style&index=0&id=c8fc90e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fc90e8",
  null
  
)

export default component.exports